<script lang="ts">
  import type { CategoryPropConfig } from '../../modules/projects/project.interface';
  import { createEventDispatcher } from 'svelte';
  import { Switch } from 'svelte-materialify';
  import Files from '../../lib/files';
  import ImageUpload from '../ImageUpload.svelte';
  import ItemPropTextInput from './ItemPropTextInput.svelte';

  export let categoryPropConfig: CategoryPropConfig;
  export let value: string;
  export let file: File;
  export let path: string;

  let isUrlInput = false;

  const dispatch = createEventDispatcher();
  $: onFileChanged(file);

  function onFileChanged(file: File) {
    if (!file) return;

    dispatch('fileAdded', Files.create(file, categoryPropConfig.key, path));
  }
</script>

<div class="item-prop-image">
  <div class="ipi-header">
    <h3>{categoryPropConfig.name || 'Image'}</h3>
    <div class="ipi-type">
      <Switch bind:checked={isUrlInput} inset>Image URL</Switch>
    </div>
  </div>
  {#if isUrlInput}
    <ItemPropTextInput {categoryPropConfig} bind:value />
  {:else}
    <ImageUpload
      bind:src={value}
      bind:file
      ratio={categoryPropConfig.requirements?.ratio}
    />
  {/if}
</div>

<style lang="scss">
  .item-prop-image {
    margin-bottom: 8px;
  }

  .ipi-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3 {
      font-size: 16px;
      margin-bottom: 6px;
    }

    .ipi-type {
      margin-left: 32px;
    }
  }
</style>
